import React from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { Widget } from './Widget';

import { DoughnutSomethingWentWrongCard } from 'src/common/components/Graphs/common/Graphs/components/DoughnutSomethingWentWrongCard';

export type DoughnutWidgetErrorBoundaryProps = {
  title: string;
  children: React.ReactNode;
};

export const DoughnutWidgetErrorBoundary = ({
  title,
  children,
}: DoughnutWidgetErrorBoundaryProps) => {
  return (
    <ErrorBoundary
      fallbackRender={() => (
        <Widget title={title}>
          <DoughnutSomethingWentWrongCard />
        </Widget>
      )}
    >
      {children}
    </ErrorBoundary>
  );
};
